import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoAndroid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.81 15a.6.6 0 0 1-.19-.06.9.9 0 0 1-.54-.54A1 1 0 0 1 14 14a1 1 0 0 1 .29-.71l.16-.12a.6.6 0 0 1 .17-.09q.09-.045.19-.06a.9.9 0 0 1 .39 0l.18.06.18.09.15.12A1 1 0 0 1 16 14c-.002.13-.029.26-.08.38a1 1 0 0 1-.21.33l-.15.12-.18.09-.18.08zM8.81 15h.39l.18-.08a.9.9 0 0 0 .54-.54A1 1 0 0 0 10 14a1 1 0 0 0-.29-.73l-.15-.12-.18-.09L9.2 13a1 1 0 0 0-.91.29A1.05 1.05 0 0 0 8 14a1 1 0 0 0 .08.4 1 1 0 0 0 .21.33q.075.068.16.12a.6.6 0 0 0 .17.09q.09.045.19.06"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.083 10.063 19.89 6.45a1 1 0 1 0-1.78-.9l-1.73 3.46a10 10 0 0 0-8.76 0L5.89 5.55a1 1 0 0 0-1.78.9l1.807 3.613A10 10 0 0 0 2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1 10 10 0 0 0-3.917-7.937m-.783 1.922A8 8 0 0 1 19.94 17H4.06a8 8 0 0 1 13.24-5.015"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoAndroid;
